__turbopack_context__.v({
  "accountData": "SidebarAccount-module__tbYnFa__accountData",
  "avatar": "SidebarAccount-module__tbYnFa__avatar",
  "chevron": "SidebarAccount-module__tbYnFa__chevron",
  "content": "SidebarAccount-module__tbYnFa__content",
  "element": "SidebarAccount-module__tbYnFa__element",
  "popover": "SidebarAccount-module__tbYnFa__popover",
  "separator": "SidebarAccount-module__tbYnFa__separator",
  "trigger": "SidebarAccount-module__tbYnFa__trigger",
  "triggerActive": "SidebarAccount-module__tbYnFa__triggerActive",
  "triggerCollapsed": "SidebarAccount-module__tbYnFa__triggerCollapsed",
  "triggerContent": "SidebarAccount-module__tbYnFa__triggerContent",
  "triggerLeft": "SidebarAccount-module__tbYnFa__triggerLeft",
  "userInfo": "SidebarAccount-module__tbYnFa__userInfo",
  "userMeta": "SidebarAccount-module__tbYnFa__userMeta",
  "userName": "SidebarAccount-module__tbYnFa__userName",
});
